// extracted by mini-css-extract-plugin
export default {"container-approve":"style_container-approve__K0NAt"};